import { Button, Input, Space } from "antd";
import { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

export function MultiTextInput({ options: valueOptions, onChange }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!options.length) return;
    else onChange(options);
  }, [options]);

  useEffect(() => {
    if (!Array.isArray(valueOptions) || !valueOptions.length) {
      setOptions([""]);
      return;
    }
    setOptions(valueOptions);
  }, [valueOptions]);

  return (
    <Space style={{ overflowX: "auto" }}>
      {options.map((o, i) => {
        return (
          <Space size={2}>
            <Input
              value={o}
              onChange={(e) => {
                options[i] = e.target.value;
                setOptions([...options]);
              }}
            />
            <Button
              icon={<DeleteOutlined />}
              onClick={() => {
                const newArr = [...options];
                newArr.splice(i, 1);
                setOptions(newArr);
              }}
              danger
            />
          </Space>
        );
      })}
      <Button
        icon={<PlusOutlined />}
        onClick={() => setOptions([...options, ""])}
      />
    </Space>
  );
}
